import React from "react";
import { observer } from "mobx-react-lite";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getCurrentCulture } from "@utils";
import BettingTipsStore from "@state/quick-play-store/BettingTipsStore";
import { ChangePageButton } from "@state/quick-play-store/MostPlayedTicketsStore";
import BettingTipQuotaButton from "../BettingTipQuotaButton";
import { BettingTips } from "@api-types/bet-booster/BettingTipsType";
import { QuickPlayPaginationButton } from "@features/quick-play/desktop/common/QuickPlayPaginationButton";

export default observer(function BettingTipsPopupFooter(props: {
	store: BettingTipsStore;
	tip: BettingTips;
}) {
	const t = useTranslation().t;
	const location = useLocation();

	const isOnQuickPlayPage = location.pathname.includes("quick-play");
	const isPrevAndNextDisabled = props.store.bettingTips.length <= 1;

	return (
		<div className="popup__footer popup__footer--bordered">
			<div className="popup__footer__left">
				{!isOnQuickPlayPage && (
					<Link
						to={`/${getCurrentCulture()}/quick-play/betting-tips`}
						className="popup--most__btn popup--most__btn--secondary btn btn--med btn--primary--inverted"
					>
						<span className="btn__label">
							{t("COMMON.SHOW_MORE")}
						</span>
					</Link>
				)}
			</div>

			<div className="popup__footer__inner popup__footer__inner--right">
				<QuickPlayPaginationButton
					direction="prev"
					onClick={() => {
						props.store.changePage(ChangePageButton.PREVIOUS);
					}}
					disabled={isPrevAndNextDisabled}
					label={t("COMMON.PREVIOUS_BUTTON")}
				/>

				<BettingTipQuotaButton
					tip={props.tip}
					isInPopup
					store={props.store}
				/>
				<QuickPlayPaginationButton
					direction="next"
					onClick={() => {
						props.store.changePage(ChangePageButton.NEXT);
					}}
					disabled={isPrevAndNextDisabled}
					label={t("COMMON.NEXT_BUTTON")}
				/>
			</div>
		</div>
	);
});
